(function(){
    'use strict';

    document.addEventListener('DOMContentLoaded', function(){
        // Lottieのアニメインスタンスを保持（stop/destroy用
        var anim = null; 

        var overlay = document.getElementById('lpc-lottie-overlay');
        // DOMがなければ終了
        if (!overlay) return;

        // Lottieの表示先
        var container = document.getElementById('lpc-lottie-canvas');

        // 各種パラメーターを取得
        var jsonUrl   = overlay.getAttribute('data-json') || '';
        var speedStr  = overlay.getAttribute('data-speed') || '2';
        var loopStr   = overlay.getAttribute('data-loop-count') || '0';
        var maxMsStr  = overlay.getAttribute('data-max-ms') || '2000';
        var exitType  = overlay.getAttribute('data-exit') || '';
        var exitMsStr = overlay.getAttribute('data-exit-ms') || '600';

        // フォールバック
        var speed   = parseFloat(speedStr);
        if (isNaN(speed) || speed <= 0) speed = 1;
        var loopCount = parseInt(loopStr, 10);
        if (isNaN(loopCount) || loopCount < 0) loopCount = 0;
        var maxMs   = parseInt(maxMsStr, 10);
        if (isNaN(maxMs) || maxMs < 0) maxMs = 2000;
        var exitMs  = parseInt(exitMsStr, 10);
        if (isNaN(exitMs) || exitMs < 0) exitMs = 600;

        // Lottieの JSON が無い（終了アニメのみ）
        if (jsonUrl === '') {
            if (container) container.style.display = 'none';
            setTimeout(function () {
                // 終了アニメーションが「なし」なら即時ページ表示
                if ( !exitType || exitType === 'none') {
                    // Domを隠す
                    hideImmediately();
                // 「あり」なら終了アニメ開始
                } else {
                    overlay.classList.add('lpc-exit');
                    overlay.classList.add('type-' + exitType);
                    requestAnimationFrame(function(){ overlay.classList.add('play'); });
                    // 規定時間でDomを隠す
                    setTimeout(function(){ 
                        hideImmediately();
                    }, exitMs);
                }
            }, Math.max(0, maxMs));
            return;
        }

        /* ユーザー環境が「動きを減らす」設定なら、即フェードで閉じる 
        var prefersReduced = false;
        try {
            prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        } catch (e) {
            prefersReduced = false; // フォールバック
        }
        if (prefersReduced) {
            // 動きを好まない環境では即フェードで閉じる
            closeOverlay(true);
            return;
        }
        */

        /* lottie-web のグローバルが無い or コンテナが無い場合は閉じる */
        var lottieObj = (typeof window !== 'undefined') ? window.lottie : null;
        if (!container || !lottieObj) {
            setTimeout(function(){ closeOverlay(true); }, Math.max(200, exitMs));
            return;
        }

        // タイマー・完了設定
        var loopsDone = 0;
        var timerId   = null;
        var finished  = false;

        // 最長表示時間が経てば強制で閉じる
        if (maxMs > 0) {
            timerId = setTimeout(function(){
                finished = true;
                closeOverlay(false);
            }, maxMs);
        }

        // アニメーション初期化
        anim = lottieObj.loadAnimation({
            container: container,
            renderer: 'svg',
            loop: false,
            autoplay: true,
            path: jsonUrl
        });

        /* DOM構築完了時にスピード反映 */
        anim.addEventListener('DOMLoaded', function () {
            if (anim && typeof anim.setSpeed === 'function') {
                anim.setSpeed(speed);
            }
        });

        /* 1周終わるたびに呼ばれる */
        anim.addEventListener('complete', function(){
            if (finished) return; /* 既に終了処理中なら無視 */
            loopsDone += 1;

            /*  指定回数未満なら先頭から再生 */
            if (loopCount > 0 && loopsDone < loopCount) {
                if (anim && typeof anim.goToAndPlay === 'function') {
                    anim.goToAndPlay(0, true); // 先頭から
                }
                return;
            }

            /* ここに来たら終了 */
            finished = true;
            if (timerId) {
                /* 最長表示タイマーを解除 */
                clearTimeout(timerId);
            }
            // 終了へ
            closeOverlay(false);
        });

        /* 即時でオーバーレイを消す関数 */
        function hideImmediately() {
            try { overlay.remove(); } catch(e) { overlay.setAttribute('hidden', 'hidden'); }
        }

        /* オーバーレイを閉じる関数 */
        var closing = false; /* 二重実行防止 */
        function closeOverlay(forceFade) {
            if (closing) return;
            closing = true;

            // Lottieを消す（前面に残らないように）
            if (container) {
                container.style.display = 'none';
            }
            if (anim && typeof anim.destroy === 'function') {
                // DOMからSVG/Canvasを除去してリソース解放
                anim.destroy();
            }

            // 終了アニメーション「なし」なら即時クローズ
            var type = forceFade ? 'fade' : exitType;
            if (!type || type === 'none') {
                hideImmediately();
                return;
            }

            // 終了アニメーション「あり」
            overlay.classList.add('lpc-exit');
            overlay.classList.add('type-' + type);

            // 終了アニメを開始
            requestAnimationFrame(function(){
                overlay.classList.add('play');
            });

            // 規定時間後にDOMを外してオーバーレイ自体を除去
            setTimeout(function(){
                hideImmediately();
            }, exitMs);
        }
    });
})();
